<fgb-mobile-page-header [pageTitle]="'mobile.page.profile.header.title'" [backButtonLink]="'/'" />

<fgb-banner class="d-lg-block d-none" [title]="name$ | async" />

<div class="container mobile-container">
  <ng-container *notInPopulation="[populations.U18]">
    <fgb-account-nav></fgb-account-nav>
  </ng-container>

  <div class="account-details-container mt-3">
    <div class="row">
      <div class="col-12 col-lg-6 order-lg-1 order-2">
        <div class="d-lg-block d-none">
          <h5 class="fw-bold mb-3 mt-lg-0 text-white text-center">{{ 'account.member.card.title' | translate }}</h5>
          <fgb-member-card></fgb-member-card>
        </div>

        <div class="order-lg-2 order-2">
          <h5 class="fw-bold mb-3 mt-4 text-white text-center">{{ 'account.questions.title' | translate }}</h5>
          <fgbcl-edit-questions [comfortEdit]="false"></fgbcl-edit-questions>
        </div>
      </div>
      <div class="col-12 col-lg-6 order-lg-2 order-1">
        <ng-container *notInPopulation="[populations.U18]">
          <h5 class="fw-bold my-lg-3 mt-lg-0 text-white text-center">{{ 'account.details.title' | translate }}</h5>
          <fgb-account-details></fgb-account-details>
        </ng-container>

        <h5 class="fw-bold my-lg-3 mt-lg-0 text-white text-center">{{ 'opt.out.title' | translate }}</h5>
        <fgb-opt-out></fgb-opt-out>
      </div>
    </div>
  </div>
</div>
